import { jsx } from "react/jsx-runtime";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { validateTidalLicense } from "../../base/index.js";
function Notifications(props) {
  return /* @__PURE__ */ jsx(
    NotificationsIcon,
    {
      "data-testid": "Notifications",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Notifications",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Notifications.tidalIconMeta = {
  categories: "common,navigation",
  name: "Notifications"
};
validateTidalLicense();
export {
  Notifications
};
//# sourceMappingURL=Notifications.js.map
